import { render, staticRenderFns } from "./ProfessionalReference.vue?vue&type=template&id=2c6abf6d&"
import script from "./ProfessionalReference.vue?vue&type=script&lang=ts&"
export * from "./ProfessionalReference.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports